/** Libellés UI globaux FR/EN — BT-028-R1 / BT-028-R2. */

export const KARATE_UI = {
  fr: {
    crud: {
      add: "Ajouter",
      edit: "Modifier",
      save: "Enregistrer",
      cancel: "Annuler",
      modify: "Modifier",
      deactivate: "Désactiver",
      actions: "Actions",
      requiredField: (label) => `Champ obligatoire : ${label}`,
    },
    table: {
      searchPlaceholder: "Rechercher…",
      searchAria: "Rechercher",
      filterAllSuffix: "Tous",
      reset: "Réinitialiser",
      empty: "Aucun élément trouvé.",
      emptyFiltered: "Aucun résultat — essayez Réinitialiser ou élargissez la recherche.",
      count: (shown, total) => `${shown} / ${total} élément(s)`,
    },
    status: {
      actif: "Actif",
      inactif: "Inactif",
      a_confirmer: "À confirmer",
    },
    visibility: {
      public: "Public",
      membres: "Réservé membres",
      admin: "Privé admin",
      a_valider: "À valider",
    },
    columns: {
      name: "Nom",
      firstName: "Prénom",
      title: "Titre",
      dojo: "Dojo",
      status: "Statut",
      email: "Courriel",
      phone: "Téléphone",
      city: "Ville",
      address: "Adresse",
      group: "Groupe",
      belt: "Ceinture",
      senseiId: "Sensei ID",
      category: "Catégorie",
      type: "Type",
      students: "Étudiants",
    },
    common: {
      yes: "Oui",
      no: "Non",
      official: "Officiel",
      demo: "Démo",
      validate: "valider",
      classify: "Classifier",
      id: "ID",
    },
    prepStatus: {
      label: "Préparation Phase 1",
      awaitingClient: "En attente du fichier client",
      dojosComplete: "Dojos officiels complets — vérifier étudiants et documents",
      demoOnly: "Mode démonstration — données [DÉMO] uniquement",
    },
    importModes: {
      replace: "Remplacer toute la collection",
      merge: "Fusionner par id (mettre à jour / ajouter)",
      replace_official: "Importer officiel — conserver [DÉMO] existantes",
    },
    demoNotice: {
      title: "Mode démonstration",
      text: "Données de démonstration — en attente du fichier officiel du Hanshi. Aucune donnée officielle n'a été inventée.",
    },
    guard: {
      title: "Administration",
      denied: "Accès réservé Hanshi / Admin.",
      login: "Connexion",
    },
    dashboard: {
      prepLine: (pct, status) => `${pct}% — ${status}`,
      targetNote: (target, official, demo, pending) =>
        `Objectif client : ${target} dojos — actuellement ${official} officiel(s), ${demo} [DÉMO], ${pending} à confirmer. En attente du fichier officiel rempli — aucune donnée officielle inventée.`,
      statDojos: "Dojos",
      statDojosDetail: (official, demo) => `${official} officiel · ${demo} [DÉMO]`,
      statDojosNoSensei: (n) => `${n} sans Sensei assigné`,
      statInstructors: "Instructeurs",
      statInstructorsUnassigned: (n) => `${n} Sensei non assignés`,
      statStudents: "Étudiants",
      statStudentsDemo: (demo, total = demo) => {
        const named = Math.max(0, total - demo);
        if (named > 0) {
          return `Jeu initial minimal — ${named} nom(s) fourni(s), ${demo} [DÉMO] test Parent ; import à venir`;
        }
        return `${demo} [DÉMO] — listes officielles en attente`;
      },
      statDocsValidate: "Docs à valider",
      manageDocuments: "Gérer documents",
      statPending: "À confirmer",
      statPendingDetail: "Lignes avec statut « à confirmer »",
      statPhase1: "Dojos manquants",
      statPhase1Detail: (missing) => `${missing} emplacement(s) officiel(s) restant(s) — objectif 10 dojos`,
      quickGroupAccounts: "Comptes & demandes",
      quickGroupData: "Données",
      quickGroupHelp: "Aide & formation",
      linkAccounts: "Comptes",
      linkRoles: "Rôles",
      linkRequests: "Demandes",
      linkImport: "Import CSV",
      linkDojos: "Dojos",
      linkInstructors: "Instructeurs",
      linkStudents: "Étudiants",
      linkDocuments: "Documents",
      linkHelp: "Aide",
      linkTraining: "Formation",
      linkPresentation: "Présentation interactive",
      outOfScope:
        "Présences, paiements et examens opérationnels sont hors Phase 1. L'import Excel client sera traité lorsque le Hanshi renverra le fichier rempli (format Excel, Word, PDF ou autre).",
      overviewTitle: "Dojos — Sensei — effectifs",
      pendingDocsTitle: "Documents à valider",
      pendingDocsWarning:
        "Ne pas publier les protocoles Black Dragon en public sans validation officielle.",
    },
    import: {
      orderNote:
        "Ordre recommandé : dojos → instructeurs / Sensei → étudiants.",
      templates: "Modèles",
      dataType: "Type de données",
      typeDojos: "Dojos",
      typeInstructors: "Instructeurs / Sensei",
      typeStudents: "Étudiants",
      importMode: "Mode d'import",
      csvContent: "Contenu CSV",
      csvPlaceholder: "Coller un CSV conforme au template (lignes # = commentaires)…",
      previewValidate: "Aperçu / valider",
      confirmImport: "Confirmer l'import",
      resetDemo: "Réinitialiser démo",
      previewTitle: "Aperçu import",
      previewOk: (total, official, demo) =>
        `Validation OK — ${total} ligne(s) (${official} officielle(s), ${demo} [DÉMO])`,
      importRefused: (errors) => `Import refusé : ${errors}`,
      importSuccess: (count, official, demo, mode) =>
        `Import réussi : ${count} ligne(s) — ${official} officielle(s), ${demo} [DÉMO]. Mode : ${mode}.`,
      resetSuccess: "Données réinitialisées aux valeurs démo Phase 1.",
    },
    documents: {
      warning:
        "Ne pas publier automatiquement les protocoles Black Dragon / rituels. Validation Hanshi requise avant « Public ».",
      classifyTitle: "Classifier le document",
      visibility: "Visibilité",
      status: "Statut",
      saved: "Document mis à jour.",
      savedWithWarning: (w) => `Enregistré. Attention : ${w}`,
      filterMembers: "Membres",
      filterAdmin: "Admin",
      empty: "Aucun document trouvé.",
      sensitiveWarning: "Document sensible — ne pas publier en public sans validation officielle du Hanshi.",
      unvalidatedWarning: "Ce document reste non publié tant qu'il n'est pas validé.",
    },
    adminPages: {
      dashboard: { title: "Tableau de bord Hanshi", subtitle: "Vue d'ensemble Phase 1 — jeu initial minimal BT-046, import massif à venir." },
      instructeurs: {
        title: "Gestion instructeurs",
        subtitle: "Sensei, Sempai et leadership — données démo ou reçues",
        subtitleR0: "Profils publics des Sensei",
      },
      dojos: { title: "Gestion dojos", subtitle: "Emplacements et assignations Sensei" },
      etudiants: {
        title: "Gestion étudiants",
        subtitle: "Membres inscrits par dojo — données PostgreSQL",
        subtitleR0: "Membres inscrits par dojo — données PostgreSQL",
        titleR0: "Membres / Étudiants",
      },
      assistants: { title: "Gestion assistants / Sempai", subtitle: "Rôle assistant — Phase 1" },
      parents: { title: "Gestion parents", subtitle: "Liens parent ↔ enfant — démo" },
      import: { title: "Import CSV", subtitle: "Valider, prévisualiser puis confirmer l'import." },
      documents: { title: "Gestion documents", subtitle: "Visibilité et validation Hanshi" },
      organisation: { title: "Organisation", subtitle: "Structure Shotokan AAMC Black Dragon" },
      classes: { title: "Classes / cours", subtitle: "Horaires hebdomadaires — données démo, horaires officiels en attente." },
      events: { title: "Événements", subtitle: "Calendrier événements — démo Phase 1." },
      presences: { title: "Présences", subtitle: "Présences légères — démo Phase 1." },
      progression: { title: "Progression", subtitle: "Suivi progression étudiants — démo." },
      ceintures: { title: "Ceintures / grades", subtitle: "Référentiel ceintures — démo." },
      examens: { title: "Examens", subtitle: "Examens — placeholder Phase 1." },
      launchCockpit: {
        pageTitle: "🚀 Lancement 1er septembre",
        pageSubtitle: "Cockpit de pilotage — état réel de l'application",
        loading: "Chargement du cockpit…",
        loadError: "Impossible de charger le cockpit.",
        updateError: "Mise à jour impossible.",
        countdown: "Compte à rebours",
        progress: "Progression",
        deadline: "Statut délai",
        activeStep: "Étape active",
        priority: "Priorité actuelle",
        nowTitle: "À faire maintenant",
        nowEmpty: "Aucune action urgente — continuez l'étape active.",
        timelineTitle: "Ligne du temps officielle",
        stepLabel: "Étape",
        statusFor: "Statut pour",
        responsible: "Responsable",
        readinessTitle: "Prêt pour le 1er septembre ?",
        readyYes: "KARATÉ EST PRÊT À OUVRIR",
        readyNo: "Pas encore prêt",
        waitingTitle: "On attend de…",
        colItem: "Élément",
        colResponsible: "Responsable",
        colStatus: "Statut",
        colNote: "Note",
        freezeTitle: "Règle de gel V1",
        freezeActive: "Gel actif — correctifs bloquants seulement.",
        phase2Title: "Phase 2 — après lancement",
        phase2Add: "Ajouter une idée",
        phase2TitleLabel: "Titre",
        phase2DescLabel: "Description (facultatif)",
        phase2DateLabel: "Date (facultatif)",
        phase2Save: "Enregistrer",
        cancel: "Annuler",
        remove: "Retirer",
      },
      comptes: { title: "Comptes & accès", subtitle: "Comptes staging temporaires et préparation courriels officiels Gilles — aucun courriel inventé." },
      preparationListe: {
        title: "Préparation liste officielle",
        subtitle: "Gabarit de collecte Gilles — import massif non activé.",
      },
      roles: { title: "Rôles", subtitle: "DojoOS / MartialCore" },
      demandes: { title: "Demandes de compte", subtitle: "Demandes locales — pas d'approbation automatique." },
      communications: { title: "Communications", subtitle: "Module communications — placeholder Phase 1." },
    },
    backendStaging: {
      dataSourceLabel: "Source des données",
      authBackend: "Auth : backend staging",
      authLocal: "Auth : local/démo Phase 1",
      demoLocalAwaiting: "Données démo/locales — en attente de branchement backend",
      managerPrepared: "Accès gestionnaire préparé — branchement backend complet à venir",
      userPrepared: "Espace utilisateur préparé — données réelles à venir",
      backendConnected: "Données backend staging",
      loading: "Chargement backend staging…",
      hybridUnreachable: "Backend staging injoignable — données locales Phase 1 utilisées.",
      hybridBackend: "Données backend staging",
      hybridHybrid: "Mode hybride — annuaire/auth backend ; autres zones peuvent rester locales/démo.",
      hybridLocal: "Données locales/démo Phase 1",
      stagingAccountsNotice: "Comptes staging temporaires — à remplacer par les courriels officiels.",
      tempPasswordNotice: "Mot de passe temporaire — à changer.",
      tempPasswordNoticeBackend: "Mot de passe staging TEMPORAIRE — à changer avant production.",
      loginSubtitleLocal: "Identifiant et mot de passe — démo locale Phase 1.",
      loginSubtitleHybrid: "Identifiants backend staging ou démo locale Phase 1.",
      demoNotice: "Comptes démo (mot de passe : demo) listés ci-dessous.",
      demoAccountsTitle: "Comptes démo disponibles",
      loginInvalidLocal:
        "Identifiants invalides — vérifiez votre courriel et votre mot de passe.",
      authError403: "Accès refusé.",
      authError401: "Identifiants invalides ou compte non disponible.",
      authErrorBackend: "Connexion au backend staging impossible.",
      linkedChildren: "Enfants liés",
      parentsEmpty: "Aucun parent trouvé.",
      managerBackendRead: "Données dojo depuis backend staging — lecture seule sauf autorisation Admin.",
      userBackendProfile: "Profil lié au backend staging.",
      postgresConnected: "Base PostgreSQL staging connectée.",
      sqliteLocal: "Base locale SQLite utilisée.",
      postgresMissing: "Configuration PostgreSQL manquante.",
      postgresReady: "Staging PostgreSQL prêt — données temporaires.",
    },
    authSecurity: {
      changePasswordTitle: "Changer le mot de passe",
      changePasswordRequired: "Vous devez changer votre mot de passe temporaire avant de continuer.",
      currentPassword: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Mettre à jour le mot de passe",
      submitting: "Mise à jour…",
      success: "Mot de passe mis à jour avec succès.",
      sameAsTemp: "Le nouveau mot de passe ne peut pas être identique au mot de passe temporaire.",
      weakPassword: "Mot de passe trop faible — minimum 6 caractères.",
      passwordMinLengthHint: "Votre mot de passe doit contenir au moins 6 caractères.",
      updateFailed: "Impossible de mettre à jour le mot de passe.",
      confirmMismatch: "Les deux mots de passe ne correspondent pas.",
      stagingEmailNotice: "Votre compte staging utilise encore un courriel temporaire.",
      mustChangeBadge: "Mot de passe temporaire — changement obligatoire",
      accountLocked: "Compte temporairement verrouillé — réessayez plus tard.",
      forceChangePassword: "Forcer changement de mot de passe",
      resetTempPassword: "Réinitialiser mot de passe temporaire (staging)",
      accountStatus: "Statut du compte",
      noHashNotice: "Aucun mot de passe ni hash n'est affiché — sécurité staging.",
    },
    accountAccess: {
      title: "Comptes & accès",
      stagingTemporary: "Compte staging temporaire — courriel officiel à confirmer.",
      officialPending: "Courriel officiel à confirmer",
      officialConfirmed: "Courriel officiel confirmé",
      emailDisabled: "Courriel désactivé",
      officialNotProvided: "Courriel officiel non fourni.",
      replaceOfficialTitle: "Remplacer par un courriel officiel",
      replaceOfficialLabel: "Courriel officiel",
      replaceOfficialPlaceholder: "saisir@domaine.exemple (fourni par Gilles)",
      replaceOfficialSubmit: "Remplacer par un courriel officiel",
      replaceSuccess: "Courriel officiel enregistré — statut à confirmer.",
      replaceError: "Erreur lors du remplacement du courriel.",
      loadError: "Impossible de charger les comptes backend.",
      localFallback: "Comptes backend — activez le mode hybride pour gérer les courriels officiels.",
      loading: "Chargement des comptes…",
      noInventNotice: "Aucun courriel officiel ne doit être inventé.",
      stagingTemporaryNotice: "Compte staging temporaire — courriel officiel à confirmer.",
      localTemporary: ".local temporaire",
      mustChangeBadge: "Mot de passe temporaire — changement obligatoire",
      forcePasswordChange: "Forcer changement mot de passe",
      forcePasswordSuccess: "Changement de mot de passe obligatoire forcé.",
      accountLocked: "Compte verrouillé",
      columnName: "Nom",
      columnRole: "Rôle",
      columnEmail: "Courriel",
      columnEmailStatus: "Statut courriel",
      columnMustChange: "MDP à changer",
      columnLastLogin: "Dernière connexion",
      columnLocked: "Verrouillé",
      columnActions: "Actions",
      selectUser: "Compte staging",
      selectUserPlaceholder: "— Sélectionner —",
      noSecretsNotice: "Aucun hash, token ou secret affiché.",
    },
    officialListPrep: {
      title: "Préparation liste officielle",
      subtitle: "Gabarit de collecte pour Gilles — aucune donnée inventée, import massif non activé.",
      intro:
        "Utilisez ce gabarit pour recevoir de Gilles la liste officielle des personnes, courriels, rôles et dojos. Les courriels seront saisis ensuite manuellement dans Comptes & accès.",
      noInventNotice: "Aucune donnée officielle ne doit être inventée.",
      bulkImportDisabled: "Import massif non activé.",
      templateTitle: "Gabarit CSV",
      templateDescription:
        "Fichier en-têtes seulement — exemples fictifs dans la documentation pilotage (marqués [EXEMPLE]).",
      downloadTemplate: "Télécharger le gabarit CSV",
      requiredFieldsTitle: "Champs requis (colonnes)",
      allowedValuesTitle: "Valeurs autorisées",
      comptesLinkTitle: "Saisie des courriels officiels",
      comptesLinkDescription:
        "Les courriels officiels seront saisis manuellement dans Comptes & accès après réception du fichier Gilles.",
      comptesLinkCta: "Ouvrir Comptes & accès",
      blackDragonTitle: "Shotokan Black Dragon",
      blackDragonNotice:
        "Les titres et reconnaissances Shotokan Black Dragon seront traités séparément à partir des documents d'autorité fournis.",
      columns: {
        action: "Action",
        personne_type: "Type de personne",
        first_name: "Prénom",
        last_name: "Nom",
        display_name: "Nom affiché",
        official_email: "Courriel officiel",
        phone: "Téléphone",
        role: "Rôle",
        dojo_name: "Nom du dojo",
        dojo_city: "Ville du dojo",
        account_needed: "Compte requis",
        temporary_access_needed: "Accès temporaire",
        must_change_password: "Changement MDP",
        status: "Statut",
        notes: "Notes",
        source_confirmation: "Confirmation source",
      },
    },
    backendCrud: {
      stagingWriteNotice: "Écriture backend staging — désactivation utilisée (pas de suppression définitive).",
      saveSuccess: "Enregistrement réussi (backend staging).",
      saveError: "Erreur lors de l'enregistrement backend.",
      validationError: "Erreur de validation — vérifiez les champs obligatoires.",
      forbidden: "Accès refusé — permissions insuffisantes.",
      deactivateConfirm: "Désactiver cet élément ? (statut inactif — pas de suppression définitive)",
      deactivateSuccess: "Élément désactivé (backend staging).",
    },
    roleLimits: {
      sempaiLimited:
        "Accès Sempai limité — aucune validation officielle de titre ou preuve n'est permise.",
      sempaiNoValidation: "Validation titre/preuve officielle non permise pour Sempai.",
      senseiNoDojo: "Aucun dojo assigné — contactez l'administration.",
      senseiDojoScope: "Données limitées à votre dojo assigné.",
      studentNoProfile: "Profil non lié — contactez l'administration.",
      studentOwnProfile: "Vous consultez uniquement votre profil.",
      parentNoChildren: "Aucun enfant lié explicitement — contactez l'administration.",
      parentLinkedChildren: "Enfants liés explicitement uniquement.",
    },
    headerProfile: {
      viewProfile: "Voir le profil",
      changePhoto: "Changer la photo",
      takePhoto: "Prendre une photo",
      uploadImage: "Téléverser une image",
      removePhoto: "Supprimer la photo",
      close: "Fermer",
    },
    accountMenu: {
      myProfile: "Mon profil",
      changePassword: "Changer mon mot de passe",
      useAppAs: "Utiliser Shotokan AAMC comme",
      currentMode: "Mode actuel",
      viewPublicSite: "Voir le site Shotokan",
      backToSite: "Retour au site",
      logout: "Déconnexion",
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
    },
    avatarManagement: {
      profilePhoto: "Photo de profil",
      useCamera: "Utiliser la caméra",
      chooseFile: "Choisir un fichier",
      removePhoto: "Supprimer la photo",
      save: "Enregistrer",
      cancel: "Annuler",
      capturePhoto: "Capturer",
      noCamera: "Aucun appareil photo disponible",
      unsupportedFormat: "Format de fichier non supporté",
      tooLarge: "Image trop volumineuse",
      invalidFile: "Fichier image invalide",
      updatedSuccess: "Photo mise à jour avec succès",
      saveFailed: "Échec de l'enregistrement de la photo",
      removeFailed: "Échec de la suppression de la photo",
      captureFailed: "Capture impossible — téléversez une image",
      serverNotConfirmed:
        "La photo a été reçue temporairement, mais elle n'a pas été confirmée par le serveur. Elle ne sera pas conservée après un rafraîchissement.",
    },
    avatarDiagnostic: {
      title: "Diagnostic avatar",
      subtitle: "Vérification autoritaire de la persistance photo (backend, disque, API).",
      verify: "Vérifier mon avatar",
      repair: "Réparer depuis le disque",
      testImage: "Tester GET image avatar",
      pass: "PASS — persistance avatar confirmée",
      fail: "FAIL — persistance avatar incomplète",
      blockingReasons: "Causes bloquantes",
      headerSource: "Source header",
      instructorCardSource: "Source carte instructeur",
      backendPreview: "Aperçu image backend",
      rawJson: "Résultat diagnostic",
      sourceBackend: "Backend (/auth/me)",
      sourceNone: "Initiales (aucun avatar backend)",
      sourceInstructorBackend: "Backend (/instructeurs)",
      sourceInstructorNone: "Initiales carte (pas d'avatar backend)",
      repairSuccess: "Réparation effectuée",
      repairFailed: "Réparation impossible",
      loading: "Vérification en cours…",
    },
    personCards: {
      avatarAlt: "Photo de profil",
      placeholder: "Initiales",
    },
    helpDrawer: {
      close: "Fermer",
      screenPrefix: "Vous êtes dans :",
      titlePrefix: "Aide —",
      purpose: "Objectif de cette page",
      actions: "Ce que vous pouvez faire ici",
      checklist: "À vérifier avant de continuer",
      mistakes: "Erreurs fréquentes",
      nextStep: "Prochaine étape recommandée",
      usefulButtons: "Boutons utiles",
    },
  },
  en: {
    crud: {
      add: "Add",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      modify: "Edit",
      deactivate: "Deactivate",
      actions: "Actions",
      requiredField: (label) => `Required field: ${label}`,
    },
    table: {
      searchPlaceholder: "Search…",
      searchAria: "Search",
      filterAllSuffix: "All",
      reset: "Reset",
      empty: "No items found.",
      emptyFiltered: "No results — try Reset or broaden your search.",
      count: (shown, total) => `${shown} / ${total} item(s)`,
    },
    status: {
      actif: "Active",
      inactif: "Inactive",
      a_confirmer: "To confirm",
    },
    visibility: {
      public: "Public",
      membres: "Members only",
      admin: "Admin private",
      a_valider: "To validate",
    },
    columns: {
      name: "Name",
      firstName: "First name",
      title: "Title",
      dojo: "Dojo",
      status: "Status",
      email: "Email",
      phone: "Phone",
      city: "City",
      address: "Address",
      group: "Group",
      belt: "Belt",
      senseiId: "Sensei ID",
      category: "Category",
      type: "Type",
      students: "Students",
    },
    common: {
      yes: "Yes",
      no: "No",
      official: "Official",
      demo: "Demo",
      validate: "validate",
      classify: "Classify",
      id: "ID",
    },
    prepStatus: {
      label: "Phase 1 preparation",
      awaitingClient: "Awaiting client file",
      dojosComplete: "Official dojos complete — verify students and documents",
      demoOnly: "Demo mode — [DEMO] data only",
    },
    importModes: {
      replace: "Replace entire collection",
      merge: "Merge by id (update / add)",
      replace_official: "Import official — keep existing [DEMO]",
    },
    demoNotice: {
      title: "Demo mode",
      text: "Demonstration data — awaiting the Hanshi's official file. No official data was invented.",
    },
    guard: {
      title: "Administration",
      denied: "Access restricted to Hanshi / Admin.",
      login: "Sign in",
    },
    dashboard: {
      prepLine: (pct, status) => `${pct}% — ${status}`,
      targetNote: (target, official, demo, pending) =>
        `Client target: ${target} dojos — currently ${official} official, ${demo} [DEMO], ${pending} to confirm. Awaiting completed official file — no invented official data.`,
      statDojos: "Dojos",
      statDojosDetail: (official, demo) => `${official} official · ${demo} [DEMO]`,
      statDojosNoSensei: (n) => `${n} without assigned Sensei`,
      statInstructors: "Instructors",
      statInstructorsUnassigned: (n) => `${n} unassigned Sensei`,
      statStudents: "Students",
      statStudentsDemo: (demo, total = demo) => {
        const named = Math.max(0, total - demo);
        if (named > 0) {
          return `Minimal initial dataset — ${named} provided name(s), ${demo} [DEMO] Parent test; import later`;
        }
        return `${demo} [DEMO] — official lists pending`;
      },
      statDocsValidate: "Docs to validate",
      manageDocuments: "Manage documents",
      statPending: "To confirm",
      statPendingDetail: "Rows with « to confirm » status",
      statPhase1: "Missing dojos",
      statPhase1Detail: (missing) => `${missing} official slot(s) remaining — target 10 dojos`,
      quickGroupAccounts: "Accounts & requests",
      quickGroupData: "Data",
      quickGroupHelp: "Help & training",
      linkAccounts: "Accounts",
      linkRoles: "Roles",
      linkRequests: "Requests",
      linkImport: "CSV import",
      linkDojos: "Dojos",
      linkInstructors: "Instructors",
      linkStudents: "Students",
      linkDocuments: "Documents",
      linkHelp: "Help",
      linkTraining: "Training",
      linkPresentation: "Interactive presentation",
      outOfScope:
        "Operational attendance, payments and exams are out of Phase 1 scope. Client Excel import will be handled when the Hanshi returns the completed file (Excel, Word, PDF or other).",
      overviewTitle: "Dojos — Sensei — headcount",
      pendingDocsTitle: "Documents to validate",
      pendingDocsWarning:
        "Do not publish Black Dragon protocols publicly without official validation.",
    },
    import: {
      orderNote: "Recommended order: dojos → instructors / Sensei → students.",
      templates: "Templates",
      dataType: "Data type",
      typeDojos: "Dojos",
      typeInstructors: "Instructors / Sensei",
      typeStudents: "Students",
      importMode: "Import mode",
      csvContent: "CSV content",
      csvPlaceholder: "Paste CSV matching the template (# lines = comments)…",
      previewValidate: "Preview / validate",
      confirmImport: "Confirm import",
      resetDemo: "Reset demo data",
      previewTitle: "Import preview",
      previewOk: (total, official, demo) =>
        `Validation OK — ${total} row(s) (${official} official, ${demo} [DEMO])`,
      importRefused: (errors) => `Import refused: ${errors}`,
      importSuccess: (count, official, demo, mode) =>
        `Import successful: ${count} row(s) — ${official} official, ${demo} [DEMO]. Mode: ${mode}.`,
      resetSuccess: "Data reset to Phase 1 demo values.",
    },
    documents: {
      warning:
        "Do not automatically publish Black Dragon protocols / rituals. Hanshi validation required before « Public ».",
      classifyTitle: "Classify document",
      visibility: "Visibility",
      status: "Status",
      saved: "Document updated.",
      savedWithWarning: (w) => `Saved. Warning: ${w}`,
      filterMembers: "Members",
      filterAdmin: "Admin",
      empty: "No documents found.",
      sensitiveWarning: "Sensitive document — do not publish publicly without official Hanshi validation.",
      unvalidatedWarning: "This document remains unpublished until validated.",
    },
    adminPages: {
      dashboard: { title: "Hanshi dashboard", subtitle: "Phase 1 overview — minimal initial dataset BT-046, bulk import later." },
      instructeurs: {
        title: "Instructor management",
        subtitle: "Sensei, Sempai and leadership — demo or received data",
        subtitleR0: "Public Sensei profiles",
      },
      dojos: { title: "Dojo management", subtitle: "Locations and Sensei assignments" },
      etudiants: {
        title: "Student management",
        subtitle: "Members enrolled by dojo — PostgreSQL data",
        subtitleR0: "Members enrolled by dojo — PostgreSQL data",
        titleR0: "Members / Students",
      },
      assistants: { title: "Assistants / Sempai management", subtitle: "Assistant role — Phase 1" },
      parents: { title: "Parent management", subtitle: "Parent ↔ child links — demo" },
      import: { title: "CSV import", subtitle: "Validate, preview then confirm import." },
      documents: { title: "Document management", subtitle: "Visibility and Hanshi validation" },
      organisation: { title: "Organisation", subtitle: "Shotokan AAMC Black Dragon structure" },
      classes: { title: "Classes / courses", subtitle: "Weekly schedule — demo data, official hours pending." },
      events: { title: "Events", subtitle: "Event calendar — Phase 1 demo." },
      presences: { title: "Attendance", subtitle: "Light attendance — Phase 1 demo." },
      progression: { title: "Progress", subtitle: "Student progress tracking — demo." },
      ceintures: { title: "Belts / grades", subtitle: "Belt reference — demo." },
      examens: { title: "Exams", subtitle: "Exams — Phase 1 placeholder." },
      launchCockpit: {
        pageTitle: "🚀 September 1 launch",
        pageSubtitle: "Launch pilot cockpit — real application status",
        loading: "Loading cockpit…",
        loadError: "Unable to load cockpit.",
        updateError: "Update failed.",
        countdown: "Countdown",
        progress: "Progress",
        deadline: "Deadline status",
        activeStep: "Active step",
        priority: "Current priority",
        nowTitle: "Do now",
        nowEmpty: "No urgent action — continue the active step.",
        timelineTitle: "Official timeline",
        stepLabel: "Step",
        statusFor: "Status for",
        responsible: "Owner",
        readinessTitle: "Ready for September 1?",
        readyYes: "KARATE IS READY TO OPEN",
        readyNo: "Not ready yet",
        waitingTitle: "Waiting on…",
        colItem: "Item",
        colResponsible: "Owner",
        colStatus: "Status",
        colNote: "Note",
        freezeTitle: "V1 freeze rule",
        freezeActive: "Freeze active — blocking fixes only.",
        phase2Title: "Phase 2 — after launch",
        phase2Add: "Add an idea",
        phase2TitleLabel: "Title",
        phase2DescLabel: "Description (optional)",
        phase2DateLabel: "Date (optional)",
        phase2Save: "Save",
        cancel: "Cancel",
        remove: "Remove",
      },
      comptes: { title: "Accounts & Access", subtitle: "Temporary staging accounts and official email preparation from Gilles — no invented emails." },
      preparationListe: {
        title: "Official List Preparation",
        subtitle: "Gilles collection template — bulk import not enabled.",
      },
      roles: { title: "Roles", subtitle: "DojoOS / MartialCore" },
      demandes: { title: "Account requests", subtitle: "Local requests — no automatic approval." },
      communications: { title: "Communications", subtitle: "Communications module — Phase 1 placeholder." },
    },
    backendStaging: {
      dataSourceLabel: "Data source",
      authBackend: "Auth: staging backend",
      authLocal: "Auth: Phase 1 local/demo",
      demoLocalAwaiting: "Demo/local data — awaiting backend connection",
      managerPrepared: "Manager access prepared — full backend connection pending",
      userPrepared: "User area prepared — real data coming later",
      backendConnected: "Staging backend data",
      loading: "Loading staging backend…",
      hybridUnreachable: "Backend staging unreachable — Phase 1 local data in use.",
      hybridBackend: "Backend staging data",
      hybridHybrid: "Hybrid mode — directory/auth from backend; other areas may stay local/demo.",
      hybridLocal: "Phase 1 local/demo data",
      stagingAccountsNotice: "Temporary staging accounts — to be replaced with official email addresses.",
      tempPasswordNotice: "Temporary password — must be changed.",
      tempPasswordNoticeBackend: "TEMPORARY staging password — change before production.",
      loginSubtitleLocal: "Username and password — Phase 1 local demo.",
      loginSubtitleHybrid: "Staging backend or Phase 1 local demo credentials.",
      demoNotice: "Demo accounts (password: demo) listed below.",
      demoAccountsTitle: "Demo accounts",
      loginInvalidLocal:
        "Invalid credentials — check your email and password.",
      authError403: "Access denied.",
      authError401: "Invalid credentials or account unavailable.",
      authErrorBackend: "Unable to sign in to the staging backend.",
      linkedChildren: "Linked children",
      parentsEmpty: "No parent found.",
      managerBackendRead: "Dojo data from staging backend — read-only unless Admin authorized.",
      userBackendProfile: "Profile linked to staging backend.",
      postgresConnected: "PostgreSQL staging database connected.",
      sqliteLocal: "Local SQLite database in use.",
      postgresMissing: "Missing PostgreSQL configuration.",
      postgresReady: "PostgreSQL staging ready — temporary data.",
    },
    authSecurity: {
      changePasswordTitle: "Change password",
      changePasswordRequired: "You must change your temporary password before continuing.",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm password",
      submit: "Update password",
      submitting: "Updating…",
      success: "Password updated successfully.",
      sameAsTemp: "The new password cannot be the same as the temporary password.",
      weakPassword: "Password too weak — minimum 6 characters.",
      passwordMinLengthHint: "Your password must contain at least 6 characters.",
      updateFailed: "Unable to update the password.",
      confirmMismatch: "The two passwords do not match.",
      stagingEmailNotice: "Your staging account is still using a temporary email address.",
      mustChangeBadge: "Temporary password — change required",
      accountLocked: "Account temporarily locked — try again later.",
      forceChangePassword: "Force password change",
      resetTempPassword: "Reset temporary password (staging)",
      accountStatus: "Account status",
      noHashNotice: "No password or hash is displayed — staging security.",
    },
    accountAccess: {
      title: "Accounts & Access",
      stagingTemporary: "Temporary staging account — official email to be confirmed.",
      officialPending: "Official email to be confirmed",
      officialConfirmed: "Official email confirmed",
      emailDisabled: "Email disabled",
      officialNotProvided: "Official email not provided.",
      replaceOfficialTitle: "Replace with an official email address",
      replaceOfficialLabel: "Official email",
      replaceOfficialPlaceholder: "enter@example.domain (provided by Gilles)",
      replaceOfficialSubmit: "Replace with an official email address",
      replaceSuccess: "Official email saved — pending confirmation status.",
      replaceError: "Error replacing email address.",
      loadError: "Unable to load backend accounts.",
      localFallback: "Backend accounts — enable hybrid mode to manage official emails.",
      loading: "Loading accounts…",
      noInventNotice: "No official email address must be invented.",
      stagingTemporaryNotice: "Temporary staging account — official email to be confirmed.",
      localTemporary: ".local temporary",
      mustChangeBadge: "Temporary password — change required",
      forcePasswordChange: "Force password change",
      forcePasswordSuccess: "Mandatory password change forced.",
      accountLocked: "Account locked",
      columnName: "Name",
      columnRole: "Role",
      columnEmail: "Email",
      columnEmailStatus: "Email status",
      columnMustChange: "Must change pwd",
      columnLastLogin: "Last login",
      columnLocked: "Locked",
      columnActions: "Actions",
      selectUser: "Staging account",
      selectUserPlaceholder: "— Select —",
      noSecretsNotice: "No hash, token or secret displayed.",
    },
    officialListPrep: {
      title: "Official List Preparation",
      subtitle: "Collection template for Gilles — no invented data, bulk import not enabled.",
      intro:
        "Use this template to receive Gilles's official list of people, emails, roles and dojos. Email addresses will then be entered manually in Accounts & Access.",
      noInventNotice: "No official data must be invented.",
      bulkImportDisabled: "Bulk import is not enabled.",
      templateTitle: "CSV template",
      templateDescription:
        "Headers-only file — fictional examples in pilotage documentation (marked [EXAMPLE]).",
      downloadTemplate: "Download CSV template",
      requiredFieldsTitle: "Required fields (columns)",
      allowedValuesTitle: "Allowed values",
      comptesLinkTitle: "Official email entry",
      comptesLinkDescription:
        "Official email addresses will be entered manually in Accounts & Access after receiving Gilles's file.",
      comptesLinkCta: "Open Accounts & Access",
      blackDragonTitle: "Shotokan Black Dragon",
      blackDragonNotice:
        "Shotokan Black Dragon titles and recognitions will be handled separately based on supplied authority documents.",
      columns: {
        action: "action",
        personne_type: "personne_type",
        first_name: "first_name",
        last_name: "last_name",
        display_name: "display_name",
        official_email: "official_email",
        phone: "phone",
        role: "role",
        dojo_name: "dojo_name",
        dojo_city: "dojo_city",
        account_needed: "account_needed",
        temporary_access_needed: "temporary_access_needed",
        must_change_password: "must_change_password",
        status: "status",
        notes: "notes",
        source_confirmation: "source_confirmation",
      },
    },
    backendCrud: {
      stagingWriteNotice: "Staging backend write — deactivation used (no permanent delete).",
      saveSuccess: "Saved successfully (staging backend).",
      saveError: "Error saving to backend.",
      validationError: "Validation error — check required fields.",
      forbidden: "Access denied — insufficient permissions.",
      deactivateConfirm: "Deactivate this item? (inactive status — not permanently deleted)",
      deactivateSuccess: "Item deactivated (staging backend).",
    },
    roleLimits: {
      sempaiLimited:
        "Limited Sempai access — official title or proof validation is not permitted.",
      sempaiNoValidation: "Official title/proof validation not permitted for Sempai.",
      senseiNoDojo: "No dojo assigned — contact administration.",
      senseiDojoScope: "Data limited to your assigned dojo.",
      studentNoProfile: "Profile not linked — contact administration.",
      studentOwnProfile: "You are viewing your profile only.",
      parentNoChildren: "No explicitly linked children — contact administration.",
      parentLinkedChildren: "Explicitly linked children only.",
    },
    headerProfile: {
      viewProfile: "View profile",
      changePhoto: "Change photo",
      takePhoto: "Take a photo",
      uploadImage: "Upload an image",
      removePhoto: "Remove photo",
      close: "Close",
    },
    accountMenu: {
      myProfile: "My profile",
      changePassword: "Change my password",
      useAppAs: "Use Shotokan AAMC as",
      currentMode: "Current mode",
      viewPublicSite: "View Shotokan website",
      backToSite: "Back to site",
      logout: "Log out",
      showPassword: "Show password",
      hidePassword: "Hide password",
    },
    avatarManagement: {
      profilePhoto: "Profile photo",
      useCamera: "Use camera",
      chooseFile: "Choose a file",
      removePhoto: "Remove photo",
      save: "Save",
      cancel: "Cancel",
      capturePhoto: "Capture",
      noCamera: "No camera available",
      unsupportedFormat: "Unsupported file format",
      tooLarge: "Image file is too large",
      invalidFile: "Invalid image file",
      updatedSuccess: "Photo updated successfully",
      saveFailed: "Failed to save photo",
      removeFailed: "Failed to remove photo",
      captureFailed: "Capture failed — upload an image instead",
      serverNotConfirmed:
        "The photo was received temporarily, but it was not confirmed by the server. It will not be kept after refresh.",
    },
    avatarDiagnostic: {
      title: "Avatar diagnostic",
      subtitle: "Authoritative photo persistence check (backend, disk, API).",
      verify: "Verify my avatar",
      repair: "Repair from disk",
      testImage: "Test GET avatar image",
      pass: "PASS — avatar persistence confirmed",
      fail: "FAIL — avatar persistence incomplete",
      blockingReasons: "Blocking reasons",
      headerSource: "Header source",
      instructorCardSource: "Instructor card source",
      backendPreview: "Backend image preview",
      rawJson: "Diagnostic result",
      sourceBackend: "Backend (/auth/me)",
      sourceNone: "Initials (no backend avatar)",
      sourceInstructorBackend: "Backend (/instructeurs)",
      sourceInstructorNone: "Card initials (no backend avatar)",
      repairSuccess: "Repair completed",
      repairFailed: "Repair not possible",
      loading: "Checking…",
    },
    personCards: {
      avatarAlt: "Profile photo",
      placeholder: "Initials",
    },
    helpDrawer: {
      close: "Close",
      screenPrefix: "You are in:",
      titlePrefix: "Help —",
      purpose: "Purpose of this page",
      actions: "What you can do here",
      checklist: "Check before continuing",
      mistakes: "Common mistakes",
      nextStep: "Recommended next step",
      usefulButtons: "Useful buttons",
    },
  },
};

export function getKarateUi(locale = "fr") {
  return KARATE_UI[locale === "en" ? "en" : "fr"];
}
